var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-root"},[_c('nuxt'),_vm._v(" "),_c('client-only',[_c('portal-target',{attrs:{"multiple":"","name":"authModal"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }